<div class="container-fluid d-flex flex-column h-100 px-0 ">
  <div class=" row h-100 m-0 pb-2 pt-2 pt-sm-4 pb-md-3 mt-md-2 pt-lg-3 pb-lg-0">
    <div class="col-12 d-flex flex-column h-100 px-3 px-md-0 pb-sm-1">
      <div class="d-flex flex-column mt-3 mt-md-1 ">
        <div class="row m-0 pt-2 border-light-grey pb-1 align-items-center pt-md-3 pt-lg-1 pb-0 ">
          <app-search-input class="col-12 col-sm-3 my-1" 
          [searchValue]="mastersRequestModelList.searchText"
          (changeSearchTextValue)="mastersRequestModelList.searchText=$event; 
          searchFilter()">
          </app-search-input>

          <app-dropdown class="col col-sm-3 my-1" 
            [options]="getAllDropdown.dateRangeDropdown"
            [dropdownLabel]="'Date Range'" 
            [id]="'dateRange'" 
            (dropdownValueEmit)="range($event)"
            [selectedId]="isCustomRange">
          </app-dropdown>

          <ng-container *ngIf="this.isCustomRange == this.dateRangeTypes.CustomRange">
            <app-range-date-picker class="col-12 col-sm-2 col-md-3 my-1" 
              (selectedDates)="selectedRangeDates($event)"
              (selectedDatesClear)="selectedRangeDatesClear()" 
              [selectedId]="isCustom1Range">
            </app-range-date-picker>
          </ng-container>

          <div class="col-auto col-sm-auto ms-sm-auto d-flex align-items-center justify-content-end gap-2 ps-2 py-2 flex-nowrap">
            <div class="mx-1 d-flex cursor-pointer"
              (click)="mastersRequestModelList.fromDate='';mastersRequestModelList.toDate='';mastersRequestModelList.searchText='';isCustomRange = null;searchFilter()">
              <app-svg-icon name="refresh" [width]="'25px'" [height]="'25px'" ngbTooltip="Reset All Filters"></app-svg-icon>            
            </div>

            <app-button class="flex-fill"
             (click)="openCreateCategoryPopup($event)" 
             [customClass]="'primary'"
             [buttonLabel]="'Create Category'"></app-button>

          </div>
        </div>
      </div>

      <app-ag-grid 
        class="d-flex flex-column h-100" 
        id="masterList" 
        [dataModel]="agGridDataModelMastersList"
        [rowData]="rowData" 
        [totalRecords]="totalRecords" 
        (gridReady)="onGridReady($event)" 
        [rowHeight]="40"
        (onPageSizeUpdated)="onChnagePage($event)"
        (onPageSizeChanged)="mastersRequestModelList.pageSize =$event;getAllMastersDataList()"
        [pageSize]="mastersRequestModelList.pageSize" 
        [page]="mastersRequestModelList.pageNumber"
        [isShowStatusDropdown]="false" 
        [isShowPlanDropdown]="false" 
        [isSubscriptionListHeader]="true"
        (onDeleteIconClick)="deleteMastersList($event)" 
        (onEditIconClick)="openCreateCategoryPopup($event)"
        (changeSearchText)="mastersRequestModelList.searchText=$event;searchFilter();">
      </app-ag-grid>

    </div>
  </div>
</div>












<!-- 
<div class="container-fluid d-flex flex-column h-100 px-0">
  <div class="row h-100 m-0 px-0">
    <div class="col-12 d-flex flex-column h-100 px-3">

      <div class="d-flex flex-column mt-3 mt-md-1">
        <div class="row m-0 pt-2 border-light-grey pb-1 align-items-center pt-md-3 pt-lg-1">

         
          <app-search-input class="col-12 col-sm-3 my-1" [searchValue]="marketingTemplateModelList.searchText"
            (changeSearchTextValue)="marketingTemplateModelList.searchText=$event; searchFilter()">
          </app-search-input>
=
          <app-dropdown class="col col-sm-3 my-1" [options]="getAllDropdown.dateRangeDropdown"
            [dropdownLabel]="'Date Range'" [id]="'dateRange'" (dropdownValueEmit)="range($event)"
            [selectedId]="isCustomRange">
          </app-dropdown>

          <ng-container *ngIf="this.isCustomRange == this.dateRangeTypes.CustomRange">
            <app-range-date-picker class="d-flex col-12 col-sm-3 my-1" (selectedDates)="selectedRangeDates($event)"
              (selectedDatesClear)="selectedRangeDatesClear()">
            </app-range-date-picker>
          </ng-container>
=
          <div
            class="col-auto col-sm-auto ms-sm-auto d-flex align-items-center justify-content-end gap-2 ps-2 py-2 flex-wrap flex-md-nowrap">

            
            <div class="mx-1 d-flex cursor-pointer"
              (click)="marketingTemplateModelList.fromDate='';marketingTemplateModelList.toDate='';marketingTemplateModelList.searchText='';isCustomRange = null;searchFilter()">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 34.55 34.788">
                <g id="Group_47854" data-name="Group 47854" transform="translate(-1739.5 -88.5)">
                  <g id="Group_47838" data-name="Group 47838" transform="translate(1754.775 86.167)">
                    <g id="Rectangle_20061" data-name="Rectangle 20061" transform="translate(-15.275 2.333)" fill="#fff"
                      stroke="#5047ff" stroke-width="1">
                      <rect width="34.55" height="34.788" rx="10" stroke="none" />
                      <rect x="0.5" y="0.5" width="33.55" height="33.788" rx="9.5" fill="none" />
                    </g>
                    <path id="Path_3874" data-name="Path 3874"
                      d="M2331.316,149.125h-4.9v4.664m8.819-12.125h4.9V137M2326,142.6a7.509,7.509,0,0,1,2.653-3.238,8.2,8.2,0,0,1,8.293-.564,7.673,7.673,0,0,1,3.112,2.844m.492,6.549a7.512,7.512,0,0,1-2.653,3.237,8.208,8.208,0,0,1-8.293.564,7.673,7.673,0,0,1-3.112-2.844"
                      transform="translate(-2331.275 -125.667)" fill="none" stroke="#5047ff" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="1" />
                  </g>
                </g>
              </svg>
            </div>

          
            <div>
              <app-button (click)="openTemplatePopup($event)" [customClass]="'primary'"
                [buttonLabel]="'Create Template'">
              </app-button>
            </div>

            
            <div>
              <app-button download="true" [customClass]="'green_button'" [buttonLabel]="'Download'"
                [disabled]="!isCheckedDownloadButtonEnable()" (click)="downloadTemplateFile()">
              </app-button>
            </div>

          </div>
        </div>
      </div>

      <app-ag-grid id="registrationList" class="d-flex flex-column h-100" [dataModel]="agGridDataModelWhatsappTemplate"
        [rowData]="rowData" [totalRecords]="totalRecords" (gridReady)="onGridReady($event)" [rowHeight]="40"
        (onPageSizeUpdated)="onChnagePage($event)"
        (onPageSizeChanged)="marketingTemplateModelList.pageSize =$event;getAllWhatsappTemplate()"
        [pageSize]="marketingTemplateModelList.pageSize" [page]="marketingTemplateModelList.pageNumber"
        [isShowStatusDropdown]="false" [isShowPlanDropdown]="false" [isSubscriptionListHeader]="true"
        (onDeleteIconClick)="deleteMarketingTemplate($event)" (onEditIconClick)="openTemplatePopup('',$event)"
        (changeSearchText)="marketingTemplateModelList.searchText=$event;searchFilter();"></app-ag-grid>
    </div>
  </div>
</div> -->